export const appRedirect = (
  action = "/login?returnUrl=" + window.location.href
) => {
  window.onbeforeunload = null;
  window.location.href = process.env.REACT_APP_GW3_MCP_LOGIN_URL + action;
};

export const url = (url) => {
  if (url !== null) {
    const urlData = decodeURIComponent(url);
    let pattern = /^(http|https?):\/\/[^\s$.?].[^\s]*$/;
    return pattern.test(urlData);
  }
  return "";
};
